// store/uiSlice.js
import { createSlice } from '@reduxjs/toolkit';

const uiSlice = createSlice({
  name: 'ui',
  initialState: {
    outletRefreshKey: 0,
    isSidebarHidden: false,
  },
  reducers: {
    refreshOutlet: (state) => {
      state.outletRefreshKey += 1;
    },
    toggleSidebar: (state, action) => {
      state.isSidebarHidden = action.payload !== undefined ? action.payload : !state.isSidebarHidden;
    },
  },
});

export const { refreshOutlet, toggleSidebar } = uiSlice.actions;
export default uiSlice.reducer;
